var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.2,72.8L48.6,2.4c-1.8-3.1-5.4-3.1-7.2,0L0.8,72.8c-0.9,1.6-1,3.1-0.3,4.3C1.2,78.3,2.5,79,4.4,79h81.3 c1.8,0,3.2-0.7,3.9-1.9C90.2,75.9,90.1,74.3,89.2,72.8z M45,72c-3.7,0-6.7-3-6.7-6.7c0-3.7,3-6.7,6.7-6.7c3.7,0,6.7,3,6.7,6.7 C51.7,69,48.7,72,45,72z M51.7,49.1c0,3.7-3,6.7-6.7,6.7c-3.7,0-6.7-3-6.7-6.7V23.6c0-3.7,3-6.7,6.7-6.7c3.7,0,6.7,3,6.7,6.7V49.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.c5f2566b6357b7f9491239259fe0e201.svg";
export { ForwardRef as ReactComponent };